import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-436e9a39"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { toRefs, ref, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Image',
  props: {
    cssClass: {},
    src: {},
    fallbackImageA: {},
    fallbackImageB: {}
  },
  setup(__props: any) {

const props = __props
// const isError = ref(false)

const { cssClass } = toRefs(props)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: _normalizeClass(_unref(cssClass)),
    src: _ctx.src
  }, null, 10, _hoisted_1))
}
}

})